import { useBrandTerminology } from './useBrandTerminology';

type MetricType = 'leads' | 'orders' | 'sales' | 'conversions';

interface MetricTerminologyOptions {
  plural?: boolean;
  context?: string;
  fallback?: string;
}

export const useMetricTerminology = () => {
  const { getTerminology, terminology, isLoading } = useBrandTerminology();

  const getMetricTypeName = (metricType: MetricType, options: MetricTerminologyOptions = {}): string => {
    const technicalTerm = `metric_${metricType}` as any;
    return getTerminology(technicalTerm, options);
  };

  const getMetricTypeNamePlural = (metricType: MetricType): string => {
    return getMetricTypeName(metricType, { plural: true });
  };

  const getMetricTypeNameSingular = (metricType: MetricType): string => {
    return getMetricTypeName(metricType, { plural: false });
  };

  // Get all metric types with their display names
  const getAllMetricTypes = () => {
    const types: MetricType[] = ['leads', 'orders', 'sales', 'conversions'];
    return types.map(type => ({
      value: type,
      label: getMetricTypeName(type, { plural: true }),
      singular: getMetricTypeName(type, { plural: false }),
    }));
  };

  return {
    getMetricTypeName,
    getMetricTypeNamePlural,
    getMetricTypeNameSingular,
    getAllMetricTypes,
    terminology,
    isLoading,
  };
};
